import { render, staticRenderFns } from "./AwaitShipmentList.vue?vue&type=template&id=0cf0368c&lang=pug&"
import script from "./AwaitShipmentList.vue?vue&type=script&lang=js&"
export * from "./AwaitShipmentList.vue?vue&type=script&lang=js&"
import style0 from "./AwaitShipmentList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports